module.exports = __webpack_public_path__ + "static/media/face-with-monocle-svgrepo-com.86f998cb.svg";